import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';

import { CheckoutSuccessComponent } from './success.component';
import { InvoiceModule } from '../../shared/components/invoice/invoice.module';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { PurchaseInfoModule } from 'src/app/shared/components/purchase-info/purchase-info.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        MatSnackBarModule,
        HeroModule,
        InvoiceModule,
        PurchaseInfoModule
    ],
  exports: [
    CheckoutSuccessComponent
  ],
  providers: [
    BreadcrumbService
  ],
  declarations: [
    CheckoutSuccessComponent
  ]
})
export class CheckoutSuccessModule { }
